import { useAuth as useRealAuth } from './RealAuthContext';
import { useMockAuth } from '@/components/auth/MockAuthContext';

export const useAuth = () => {
    // Check for environment variable to determine which auth to use
    const useMockAuthentication = import.meta.env.VITE_USE_MOCK_AUTH === 'true';

    if (useMockAuthentication) {
        return useMockAuth();
    }

    return useRealAuth();
};